const Bone = ({ className }: { className: string }) => (
  <div className={`c-accommodation-skeleton__bone ${className}`} />
);

export const AccommodationSkeleton = () => {
  return (
    <div className="c-accommodation-skeleton">
      <div className="c-accommodation-skeleton__top">
        <div className="c-accommodation-skeleton__gallery">
          <Bone className="c-accommodation-skeleton__gallery-bone" />
        </div>
        <div className="c-accommodation-skeleton__info">
          <div className="c-accommodation-skeleton__info-content">
            <Bone className="c-accommodation-skeleton__title" />
            <Bone className="c-accommodation-skeleton__price" />
            <Bone className="c-accommodation-skeleton__capacity" />
            <div className="c-accommodation-skeleton__amenities">
              <Bone className="c-accommodation-skeleton__amenity" />
              <Bone className="c-accommodation-skeleton__amenity" />
              <Bone className="c-accommodation-skeleton__amenity" />
            </div>
          </div>
          <Bone className="c-accommodation-skeleton__details-link" />
        </div>
      </div>
      <div className="c-accommodation-skeleton__rates">
        <div className="c-accommodation-skeleton__rate-row">
          <div className="c-accommodation-skeleton__rate-left">
            <Bone className="c-accommodation-skeleton__rate-name" />
            <Bone className="c-accommodation-skeleton__rate-meta" />
          </div>
          <Bone className="c-accommodation-skeleton__rate-price" />
        </div>
        <div className="c-accommodation-skeleton__rate-row">
          <div className="c-accommodation-skeleton__rate-left">
            <Bone className="c-accommodation-skeleton__rate-name" />
            <Bone className="c-accommodation-skeleton__rate-meta" />
          </div>
          <Bone className="c-accommodation-skeleton__rate-price" />
        </div>
      </div>
    </div>
  );
};
